angular.module('impactx').service('$securityManager', SecurityManager);
SecurityManager.$inject = [
    'cookieService',
    '$redirect',
    'TranslationService',
    'ToastService',
    'ReloginExternalService',
    '$config'
];

function SecurityManager(cookieService, $redirect, TranslationService, ToastService, ReloginExternalService, $config) {
    var CONST_AUTH_TOKEN_NAME = "authToken";
    this.allowedProcesses = {};
    this.isInitialized = false;
    this.stayLoggedIn = false;

    this.isAuthorized = function () {
        var token = this.getToken();
        return token !== null && token !== undefined;
    };

    this.setToken = function (token) {
        var expirationDays = this.stayLoggedIn ? 300 : null;
        cookieService.setCookie(CONST_AUTH_TOKEN_NAME, token, expirationDays, configData.useSecureCookie);
    };

    this.deleteToken = function () {
        cookieService.removeCookie(CONST_AUTH_TOKEN_NAME);
    };

    this.deleteTokenAndRedirect = function () {
        cookieService.removeCookie(CONST_AUTH_TOKEN_NAME);
        if (ReloginExternalService.isExternalUser()) {
            $redirect.redirectTo(null, '/relogin.external');
        }
        else {
            var loginPageCookie = cookieService.getCookieValue('loginPage');
            if (loginPageCookie) {
                $redirect.redirectTo(null, $config.customLoginRoute + '/' + loginPageCookie);
            }
            else {
                $redirect.redirectTo(null, $config.loginRoute);
            }
        }
        var reLoginMessage = TranslationService.get("reLogin");
        if (reLoginMessage) {
            ToastService.openStandardToast(reLoginMessage);
        }
    };

    this.getToken = function () {
        return cookieService.getCookieValue(CONST_AUTH_TOKEN_NAME);
    };

    this.setAllowedProcesses = function (processes) {
        this.isInitialized = true;
        this.allowedProcesses = processes;
    };


    this.isProcessAllowedWatch = function ($scope, processName, callback) {
        if (!this.isInitialized) {
            var secManager = this;
            $scope.$watch(function () {
                return secManager.isInitialized;
            }, function (newVal) {
                if (newVal) {
                    callback(secManager.isProcessAllowed(processName));
                }
            });
            return false;
        }
        else {
            callback(this.isProcessAllowed(processName));
        }

    };

    this.isSuperUser = function () {
        return this.allowedProcesses.length === 0;
    };

    this.isProcessAllowed = function (processName) {
        var isAllowed = true;
        if (this.allowedProcesses && this.allowedProcesses.length > 0) {
            isAllowed = this.allowedProcesses.indexOf(processName) > -1;
        }
        return isAllowed;
    };

    this.hasProcessesSet = function () {
        return this.allowedProcesses && this.allowedProcesses.length > 0;
    };

    this.isOnlyAllowed = function (processName) {
        return (this.allowedProcesses && this.allowedProcesses.length == 1 && this.allowedProcesses[0] === processName);
    };

    this.invalidate = function () {
        this.isInitialized = false;
        this.allowedProcesses = {};
        this.deleteToken();
    };

    this.invalidateProcesses = function () {
        this.isInitialized = false;
        this.allowedProcesses = {};
    };

    /*
    this.$get = function () {
        console.log('Get called!');
        return {
            isAuthorized: this.isAuthorized,
            setToken: this.setToken,
            deleteToken: this.deleteToken,
            getToken: this.getToken,
            deleteTokenAndRedirect: this.deleteTokenAndRedirect,
            allowedProcesses: this.allowedProcesses,
            isProcessAllowed: this.isProcessAllowed,
            setAllowedProcesses: this.setAllowedProcesses,
            isProcessAllowedWatch: this.isProcessAllowedWatch,
            invalidate: this.invalidate,
            invalidateProcesses: this.invalidateProcesses,
            isInitialized: function() {
                return self.isInitialized;
            },
            isSuperUser: this.isSuperUser,
            hasProcessesSet: this.hasProcessesSet
        }
    };
    */
}